'use strict';

var ajax = require('../../ajax'),
	dialog = require('../../dialog'),
	quantity = require('./quantity'),
	util = require('../../util'),
	search = require('../search'),
	TPromise = require('promise'),
	validator = require('../../validator'),
	linchpin = require('int_googletagmanager/linchpin/hampers');

var currentHamper,
	hamperErrors,
	$minicartElement = $('.show-minicart');

/**
 * @description Calculate the number of items in each hamper.
 */
function calculateItemCount(data) {
	var itemCount = 0;
	var components = data.container.components;

	for (var i = 0; i < components.length; i++) {
		itemCount += parseInt(components[i].quantity, 10);
	}
	return itemCount;
}

/**
 * @description Calculate how much of the hamper volume is being used.
 */
function calculateHamperVolume(data) {
	var totalVolume = 0;
	var components = data.container.components;

	for (var i = 0; i < components.length; i++) {
		totalVolume += parseInt(components[i].quantity, 10) * components[i].volumeScore;
	}
	return totalVolume;
}

/**
 * @description Given a ProductID, find out the quantity that exists
 * in the current hamper.  This number does not take into acount the
 * container quantity.
 */
function getProductQtyInCurrentHamper(pid) {
	var qty = 0;
	if (typeof currentHamper !== 'undefined' && currentHamper !== null) {
		var components = currentHamper.container.components;
		for (var i = 0; i < components.length; i++) {
			if (components[i].pid === pid) {
				qty = parseInt(components[i].quantity, 10);
			}
		}
	}
	return qty;
}

/**
 * @description Update the current hamper on the page.  Details such as the
 * hamper price and number of items will be updated here.
 */
function showCurrentHamperStatus(showStatus) {
	if (showStatus === false) {
		$('.current-hamper-status').hide();
	} else {
		$('.current-hamper-status').show();
	}
}

/**
 * @description Update the current hamper on the page.  Details such as the
 * hamper price and number of items will be updated here.
 */
function updateCurrentHamperDetails(data) {
	$('#currentHamperImage').attr('src', data.container.image);
	$('#currentHamperImage').attr('alt', data.container.name);
	$('#currentHamperName').text(data.container.name);
	var hamperVolume = calculateHamperVolume(data);
	$('#currentHamperVolume').val(hamperVolume);
	var percentage = hamperVolume / parseInt(data.container.capacity, 10);
	percentage = parseInt(percentage * 100, 10);
	$('#currentHamperPercentage').text(percentage);
	util.drawProgressWheel(percentage / 100, 'currentHamperGraph');
	var itemCount = calculateItemCount(data);
	var $hampersYourItems = $('#hampers-your-items');
	$hampersYourItems.find('.count').text(itemCount);
	if (itemCount > 0) {
		$hampersYourItems.removeClass('disabled-ref');
	} else {
		$hampersYourItems.addClass('disabled-ref');
	}
	if (itemCount === 1) {
		$('#currentHamperItemCount').text(itemCount + ' ' + Resources.ITEM);
	} else {
		$('#currentHamperItemCount').text(itemCount + ' ' + Resources.ITEMS);
	}
	$('#currentHamperItemCount').data('item-count', itemCount);
	$('#currentHamperUnitPrice').text(data.unitPrice);
	$('#currentHamperQuantity').text(data.container.quantity);
	$('#currentHamperTotalPrice').text(data.totalPrice);
	if (data.container.components.length > 0) {
		$('.view-items').prop('disabled', false);
		$('.current-hamper-save').prop('disabled', false);
		$('.current-hamper-cart').prop('disabled', false);
	} else {
		$minicartElement.removeClass('show');
		$('.view-items').prop('disabled', true);
		$('.current-hamper-save').prop('disabled', true);
		$('.current-hamper-cart').prop('disabled', true);
	}
	// Update tag manager hamper details
	if (data.tagManagerData && $('input[name=currentHamper]').length > 0) {
		$('input[name=currentHamper]').val(JSON.stringify(data.tagManagerData));
	}
	showCurrentHamperStatus(true);
	updateTileButtons();
}

function pageUpdateAfterRemove (callback) {
	var currentHref = $('#hampers-your-items').data('current-href');
	var uri = null;
	if (typeof currentHref !== 'undefined' && typeof window.history.pushState === 'function') {
		uri = util.getUri(currentHref);
		search.updateProductListing(uri.query.substring(1), false, callback);
	} else {
		//@TODO If no history interface in window object currenlty its only run callback
		callback();
	}
}
/**
 * @description Update the minicart that shows the items in the
 * current hamper.
 */
function updateCurrentHamperMinicart () {
	ajax.load({
		url: Urls.hamperMinicart,
		target: $('.show-minicart'),
		callback: function () {
			$minicartElement.addClass('hover');
			addHamperToCartCTA($minicartElement.find('.currentHamperCheckoutForm'));
			hamperMiniCartLayer();
			$('.hamper-occupancy').addClass('hover');
			$('.remove-component').on('click', function (event) {
				var $form = $(this).closest('form');
				var formUrl = $form.attr('action');
				var formData = util.serializeJSON($form);
				sendAjaxMessage(formUrl, formData, function () {
					pageUpdateAfterRemove(updateCurrentHamperMinicart);
				});
				event.preventDefault();
			});
		}
	});
}
/**
 *
 * @param thisElement - either add-to-hamper button or qty field after enter pressed
 * @param e {object} -event object need stop default actions
 */
function qvFormSubmission (thisElement, e) {
	e.preventDefault();
	var $form = $(thisElement).closest('.pdpComponentForm');
	var productId = $form.find('input[name="pid"]').val();
	var $qtyInput = $form.find('.input-group-qty');
	var formUrl = $form.attr('action');
	var formData = util.serializeJSON($form);
	var updateTileQuantity = function () {
		$.each($('.tileComponentForm'), function () {
			var $form = $(this);
			var pid = $form.find('input[name="pid"]').first().val();
			if (pid === productId) {
				$form.find('input[name="Quantity"]').first().val($qtyInput.val());
				return false;
			}
		});
	};
	sendAjaxMessage(formUrl, formData, updateTileQuantity);
}

/**
 * @description Initialize the quickview so it adds components
 * to the current hamper.
 */
function initializeQuickview () {
	var $form = $('.quickview-dialog .pdpComponentForm'),
		$submitButtons = $form.find('.select-component, .update-component'),
		$qtyInput = $form.find('.input-group-qty');

	//handlers for qv add-to-hamper submit clicked
	$submitButtons.on('click', function (e) {
		qvFormSubmission(this, e);
	});

	//handlers for qv add-to-hamper enter pressed
	$qtyInput.keypress(function (e) {
		if (e.which === 13) {
			qvFormSubmission(this, e);
		}
	});

	//update once qv loaded and assign same handler if qty change
	updateTileButtons();
	$qtyInput.on('change', function () {
		updateTileButtons();
	});

}

/**
 * @description Update the buttons to show warnings and disable/enable buttons
 * for the select, update, etc.
 */
function updateTileButtons () {
	var currentHamperVolume = parseInt($('#currentHamperVolume').val(), 10);
	$.each($('.tileComponentForm'), function () {
		var $form = $(this);
		var pid = $form.find('input[name="pid"]').first().val();
		var qtyElement = $form.find('input[name="Quantity"]').first();
		var qty = parseInt(qtyElement.val(), 10);
		var isValid = true;
		// If the value isn't a number or is negative, go back to the original value.
		if (isNaN(qty) || qty < 0) {
			isValid = false;
			setTimeout(function () {
				var newQty = parseInt(qtyElement.val(), 10);
				if (isNaN(newQty) || newQty < 0) {
					if ($form.data('type') === 'container') {
						if (typeof currentHamper !== 'undefined' && currentHamper !== null) {
							qty = currentHamper.container.quantity;
						} else {
							qty = 1;
						}
					} else if ($form.data('type') === 'component') {
						qty = getProductQtyInCurrentHamper(pid);
						if (qty === 0) {
							qty = 1;
						}
					}
					qtyElement.val(qty);
					hamperTileValidate($form, qty, pid, currentHamperVolume);
				}
			}, 2000);
		// If the qunatity value is different, replace it with the parsed value.
		} else if (qtyElement.val() !== String(qty)) {
			qtyElement.val(qty);
		}
		if (isValid) {
			hamperTileValidate($form, qty, pid, currentHamperVolume);
		}
	});
}
function hamperTileValidate ($form, qty, pid, currentHamperVolume) {
	var $warningElement = null,
		$selectButton = null,
		$updateButton = null,
		$removeButton = null,
		hamperVolumeScore = null,
		currentComponentQty = null,
		components = null;

	if (typeof currentHamper !== 'undefined' && currentHamper !== null) {
		// only define components if the current hamper exists
		components = currentHamper.container.components;
	}
	if ($form.data('type') === 'container') {
		// check to see if this product tile is for a hamper container
		$warningElement = $form.find('.warning-container').first();
		$selectButton = $form.find('.select-container').first();
		$updateButton = $form.find('.update-container').first();
		if (typeof currentHamper === 'undefined' || currentHamper === null) {
			// disable the update button if there is no current hamper
			$selectButton.removeClass('hidden');
			$updateButton.addClass('hidden');
		} else if (currentHamper.container.pid === pid) {
			// disable the select button if it is the current hamper container
			$selectButton.addClass('hidden');
			$updateButton.removeClass('hidden');
			if (currentHamper.container.quantity === qty) {
				$updateButton.prop('disabled', true);
			} else {
				$updateButton.prop('disabled', false);
			}
		} else {
			// otherwise enable the select button only
			$selectButton.removeClass('hidden');
			$updateButton.addClass('hidden');
		}
		if ($warningElement.data('hamper-capacity') < currentHamperVolume) {
			// show the warning if the current hamper is bigger than this one's capacity
			$selectButton.addClass('hidden');
			$updateButton.addClass('hidden');
			$warningElement.show();
		} else {
			//  hide the warning if this is not above the hamper capacity
			$warningElement.hide();
		}
	} else if ($form.data('type') === 'component') {
		// check to see if this product tile is for a hamper component
		$warningElement = $form.find('.warning-component').first();
		$selectButton = $form.find('.select-component').first();
		$updateButton = $form.find('.update-component').first();
		$removeButton = $form.find('.remove-component').first();
		$selectButton.removeClass('hidden');
		$updateButton.addClass('hidden');

		$form.closest('.grid-tile').removeClass('error');

		//check components array of the given hamper
		if (components !== null) {
			//show update and hide select buttons of already chosen components of given hamper
			for (var i = 0; i < components.length; i++) {
				if (components[i].pid === pid) {
					$selectButton.addClass('hidden');
					$updateButton.removeClass('hidden');
				}
			}
		} else {
			window.location = Urls.hamperLanding;
			return;
		}

		hamperVolumeScore = parseInt($selectButton.data('hamper-volume-score'), 10);
		currentComponentQty = getProductQtyInCurrentHamper(pid);
		if (hamperErrors) {
			for (var j = 0; j < hamperErrors.componentProducts.length; j++) {
				if (hamperErrors.componentProducts[j].pid === pid && hamperErrors.componentProducts[j].availablequantity) {
					qty = hamperErrors.componentProducts[j].availablequantity;
					// TODO: mark the tile with an error class that is designed to match the comps
					$form.closest('.grid-tile').addClass('error');
					$form.find('input[name="Quantity"]').first().val(qty);
					break;
				}
			}
		}

		//disable user action if qty the same
		if (qty === currentComponentQty) {
			$selectButton.prop('disabled', true);
			$updateButton.prop('disabled', true);
		} else {
			$selectButton.prop('disabled', false);
			$updateButton.prop('disabled', false);
		}

		//hamper capacity verification
		if (((hamperVolumeScore * (qty - currentComponentQty)) + currentHamperVolume) > currentHamper.container.capacity) {
			// disable select and update if this current qty would push it over capacity
			$selectButton.prop('disabled', true);
			$updateButton.addClass('hidden');
			$warningElement.text(Resources.TOO_LARGE);
			$warningElement.show();
		} else {
			// hide the warning if this qty will not exceed the hamper capacity
			$warningElement.hide();
		}
		if (currentComponentQty > 0) {
			$removeButton.removeClass('disabled');
		} else {
			$removeButton.addClass('disabled');
		}
	}
}
/**
 * @description Update the buttons to show warnings and disable/enable buttons
 * for the select, update, etc.
 */
function markTileInvalidQuantity(productID, quantity) {
	$.each($('.tileComponentForm'), function () {
		var $form = $(this);
		var pid = $form.find('input[name="pid"]').first().val();
		if (pid === productID) {
			$form.find('input[name="Quantity"]').first().val(quantity);
			// TODO: mark the tile with an error class that is designed to match the comps
			$form.closest('.grid-tile').addClass('error');
			return true;
		}
	});
}

/**
 * @description Sends a message to the specified URL with a product ID and
 * a quantity.  If the response is not an error, the current hamper details on
 * the page will be updated.  If there is an error, the error code will be used
 * to display an error message.
 */
function sendAjaxMessage(formUrl, formData, callback) {
	ajax.getJson({
		url: formUrl,
		data: formData,
		callback: function (data) {
			var notificationUrl = null;
			if (!data) {
				window.alert(Resources.SERVER_ERROR);
				return false;
			} else if (data.success === false) {
				if (data.code === 'itemunavailable' || data.code === null) {
					var pids = new Array(formData.pid);
					var buttonFunction = function () {
											dialog.close();
										};
					itemUnavailableDialog(pids, buttonFunction);
					return false;
				} else {
					notificationUrl = util.appendParamsToUrl(Urls.hamperNotification, {pid: formData.pid, errorcode: data.code});
				}
				dialog.open({
					url: notificationUrl,
					options: {
						dialogClass: 'no-title',
						open: function () {
							$('.close-dialog').on('click', function () {
								dialog.close();
							});
						}
					}
				});
				return false;
			} else {
				currentHamper = data;
				ajax.getJson({
					url: Urls.getHamperErrors,
					data: {id: data.id},
					callback: function (errorData) {
						hamperErrors = errorData;
						updateCurrentHamperDetails(data);
						hamperErrors = null;
						if (typeof callback === 'function') {
							callback.call();
						}
					}
				});

				return true;
			}
		}
	});
}
/**
 * @description check if it's mobile onload and hide all refinements
 * assign event handler to the filter button to toggle active state, which
 * means all refinements activated
 */
function initMobileFilterButton () {
	var $filterBtn = $('.hamper_mb_filter'),
		$refinements = $('.refinements .refinement').not('.reset');

	if (util.viewport.isSmall()) {
		$refinements.removeClass('active');
	}
	$filterBtn.on('touchstart click', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		if ($(this).hasClass('active')) {
			$refinements.addClass('active').show();
		} else {
			$refinements.removeClass('active').hide();
		}
	});
}
/**
 * @description Initialize hampers tabs.
 */
function initializeDom() {
	return new TPromise(function (resolve) {
		ajax.getJson({
			url: Urls.getCurrentHamper,
			callback: function (data) {
				if (!data) {
					resolve();
				} else if (data.success === false) {
					updateTileButtons();
					resolve();
					//return false;
				} else {
					currentHamper = data;
					// set the quantities on the product tiles
					$.each($('.tileComponentForm'), function () {
						var $form = $(this);
						var pid = null;
						var qty = null;
						if ($form.data('type') === 'component') {
							pid = $form.find('input[name="pid"]').first().val();
							qty = getProductQtyInCurrentHamper(pid);
							if (qty > 0) {
								// set the quantity if the number in the hamper is over zero
								$form.find('input[name="Quantity"]').first().val(qty);
							}
						} else if ($form.data('type') === 'container') {
							qty = currentHamper.container.quantity;
							if (qty > 0) {
								// set the quantity if the number of hampers is over zero
								$form.find('input[name="Quantity"]').first().val(qty);
							}
						}
					});
					ajax.getJson({
						url: Urls.getHamperErrors,
						data: {id: data.id},
						callback: function (errorData) {
							hamperErrors = errorData;
							updateCurrentHamperDetails(data);
							hamperErrors = null;
						}
					});
					// Save hamper container JSON data
					var containerDetails = JSON.stringify(data.container);
					$('input[name="hamperContainerDetails"]').val(containerDetails);
					$minicartElement = $('.show-minicart');
					resolve();
				}
			}
		});
	});
}

/**
 * @description Initialize event handlers on hampers pages
 */
function initializeEvents() {
	$('#hampers-tabs-mobile ul.tabs-menu').on('click', 'li > a', function (e) {
		e.preventDefault();
		var $tab = $(this).parent('li');
		// $tab.siblings().removeClass('active-tab');
		$tab.toggleClass('active-tab');
	});
	$('.tab-target-desktop').tabs();
	// Toggles tab content on click
	$('.descSection3 h3').on('click touchstart', function (e) {
		$(this).toggleClass('active');
		e.preventDefault();
	});

	// Toggles mobile hamper status accordion on click
	$('.mobile-status-header').off().on('click touchstart', function (e) {
		e.stopPropagation();
		e.preventDefault();
		$('.hamper-status-container').toggleClass('show');
		$(this).toggleClass('on');
	});

	$('#secondary .refinement a').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.hamperFiltersEvent(e);
		}
	});

	$('div .sort-by').on('change', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.hamperSortEvent(e);
		}
	});

	// classes for adding or updating component quantity
	$('.search-result-content').on('click', '.select-component, .update-component', function (e) {
		var $form = $(this).closest('form');
		var formUrl = $form.attr('action');
		var formData = util.serializeJSON($form);
		var callback = function () {
			// GTM Linchpin analytics
			linchpin.addItemToHamperEvent(e, formData);
		};

		sendAjaxMessage(formUrl, formData, callback);

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.hamperSelectEvent(e);
		}
		e.preventDefault();
	});

	// class for removing a component from the current hamper
	$('.search-result-items').on('click', '.remove-component', function (e) {
		var $form = $(this).closest('form'),
			formUrl = $form.attr('action'),
			formData = util.serializeJSON($form);
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.removeItemFromHamperEvent(e, formData);
		}
		sendAjaxMessage(formUrl, formData, function () {
			pageUpdateAfterRemove();
		});

	});


	// these classes are container changes and premade hampers
	$('.select-container, .select-hamper, .update-container').on('click', function (e) {
		var $form = $(this).closest('form');
		updateSelection($form);
		e.preventDefault();
	});

	// submit the form on pressing the enter key
	$('.search-result-items').keypress('.input-group-qty', function (e) {
		var key = e.which;
		var enterKeyCode = 13;
		if (key === enterKeyCode) {
			var $form = $(this).closest('form');
			updateSelection($form);
			e.preventDefault();
		}
	});

	quantity.init(updateTileButtons);

	//View hamper minicart
	$('.view-items').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.viewHamperItemsEvent(e);
		}
		if ($('.show-minicart').hasClass('hover')) {
			$('.show-minicart').removeClass('hover');
			$('.uiLayerIndicator').remove();
		} else {
			updateCurrentHamperMinicart();
			e.preventDefault();
		}
	});

	//Hamper minicart close icon
	$('.show-minicart ').on('click touchstart', '.close', function (e) {
		e.preventDefault();
		$('.show-minicart').removeClass('hover');
		$('.uiLayerIndicator').remove();
	});

	// save the current hamper to the wishlist
	$('.currentHamperSaveForm').on('click', ':button', function (e) {
		e.preventDefault();
		dialog.open({
			url: Urls.hamperSaveDialog,
			options: {
				title: Resources.SAVE_HAMPER_DIALOG_TITLE,
				dialogClass: 'save-hamper-dialog',
				open: function () {
					validator.init();
				},
				buttons: []
			}
		});
	});

	addHamperToCartCTA($('.currentHamperCheckoutForm'));
	initMobileFilterButton();
}

var addHamperToBagDialog = function () {
	validator.init();
	var $addHamperToBagForm = $('#addCurrentHamperForm');
	$addHamperToBagForm.find('input[name="name"]').val(currentHamper.name);
	$addHamperToBagForm.on('click', ':button', function () {
		if (!$addHamperToBagForm.valid()) {
			return;
		}
		$(this).addClass('clicked');
	});
	$addHamperToBagForm.submit(function (event) {
		event.preventDefault();
		if (!$addHamperToBagForm.valid()) {
			return;
		}
		var params = $addHamperToBagForm.serialize(),
			$clickedButton = $addHamperToBagForm.find('button.clicked');
		// Add the value of the clicked button to the parameters
		params = params + '&type=' + encodeURIComponent($clickedButton.val());

		$.ajax({
			url: $addHamperToBagForm.attr('action'),
			data: params
		}).done(function (data) {
			//TODO: Add a generic error message when a hamper can't be added to a cart
			if ($(data).filter('#auto-accept').length) {
				$('body').append(data);
				$('#auto-accept').submit();
			} else if (data.success === false && data.error === 'CART_MAX') {
				dialog.replace({
					url: Urls.maxLineItemQuota,
					options: {
						buttons: [
							{
								text: Resources.GOT_IT,
								click: function () {
									$(this).dialog('close');
								}
							}
						],
						title: Resources.MAX_QUOTA_TITLE
					}
				});
			} else if (data.success === false && data.error === 'TC_DEBT') {
				dialog.open({
					url: Urls.tcSettleBalanceError,
					options: {
						buttons: [
							{
								text: Resources.CANCEL,
								'class':'button-gray',
								click: function () {
									$(this).dialog('close');
								}
							},
							{
								text: Resources.SETTLE_BALANCE,
								click: function () {
									window.location = Urls.shippingStart;
								}
							}
						],
						title: Resources.SORRY
					}
				});
			} else {
				dialog.open({
					url: Urls.requestErrorMessage,
					options: {
						buttons: [
							{
								text: Resources.GOT_IT,
								click: function () {
									$(this).dialog('close');
								}
							}
						],
						title: Resources.SORRY
					}
				});
			}
		});
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.hamperAddToBagEvent(event, params);
		}
	});
	$('.current-hamper-status').on('click touchstart', '.close', function (e) {
		e.preventDefault();
		$(this).closest('.show-minicart').removeClass('hover');
		$('.uiLayerIndicator').remove();
	});
};

// popup asking for hamper name before adding it to cart
function addHamperToCartCTA($checkoutForm) {
	$checkoutForm.on('click', ':button', function (e) {
		e.preventDefault();
		dialog.open({
			url: Urls.hamperAddToBagDialog,
			options: {
				title: Resources.ADD_HAMPER_TO_BAG_DIALOG_TITLE,
				dialogClass: 'add-hamper-to-bag-dialog',
				buttons: {},
				open: addHamperToBagDialog
			}
		});
	});
}

function itemUnavailableDialog (pids, buttonFunction) {
	var notificationUrl = util.appendParamsToUrl(Urls.hamperUnavailable, {pids: pids.join(',')});
	dialog.open({
		url: notificationUrl,
		options: {
			dialogClass: 'hampers-unvailable-list',
			buttons: [
						{
							text: Resources.GOT_IT,
							click: buttonFunction
						}
					],
			title: Resources.ITEMS_UNAVAILABLE,
			open:function () {
				setTimeout(function () {
					var listContainer = document.getElementById('hamper-list-scroll-wrapper');
					if ($(listContainer).hasClass('scroll')) {
						new IScroll(listContainer, util.iscrollParams());
					}
				}, 20);
			}
		}
	});
}

function initializeDomAndEvents() {
	initializeDom().then(initializeEvents);
}


var hampers = {
	initializeEvents: initializeEvents,
	init: function () {
		initializeDomAndEvents();
		search.init(initializeDomAndEvents);
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.hamperViewEvent();
		}
	},
	itemUnavailableDialog: itemUnavailableDialog,
	initializeQuickview: initializeQuickview
};

function updateSelection($form) {
	// a callback function to forward to components after changing a container
	var forwardToComponents = function () {
		window.location = Urls.hamperComponents;
	};
	// a callback function to forward to your hamper components
	var forwardToYourComponents = function () {
		window.location = util.appendParamToURL(Urls.hamperComponents, 'hamperitems', 'true');
	};
	var formUrl = $form.attr('action');
	var formData = util.serializeJSON($form);
	var pids = [];
	if (typeof currentHamper === 'undefined' && $form.data('type') === 'container') {
		formUrl = Urls.createHamper;
		sendAjaxMessage(formUrl, formData, forwardToComponents);
	} else if ($form.data('type') === 'premade') {
		ajax.getJson({
			url: Urls.getPreMadeHamperErrors,
			data: formData,
			callback: function (data) {
				if (typeof data.containerErrors !== 'undefined') {
					if (data.containerErrors.length > 0) {
						// If the container is out of stock or unavailable, the the pid of the container.
						if (data.containerErrors.indexOf('outofstock') >= 0 || data.containerErrors.indexOf('unavailable') >= 0) {
							pids.push(data.containerProduct);
						// If the hamper has an error besides a component error add a pid of the hamper.
						} else if (data.containerErrors.indexOf('componenterror') < 0 || data.containerErrors.length > 1) {
							pids.push(formData.pid);
						}
						if (data.containerErrors.indexOf('componenterror') >= 0) {
							for (var i = 0; i < data.componentProducts.length; i++) {
								if (data.componentProducts[i].errors.length > 0) {
									pids.push(data.componentProducts[i].pid);
								}
							}
						}

						if (pids.length > 0) {
							var buttonFunction = function () {
								dialog.close();
							};
							itemUnavailableDialog(pids, buttonFunction);
						}
					} else {
						// if there were no expected errors, submit the form
						$form.submit();
					}
				} else {
					// display a generic error message
					dialog.open({
						url: Urls.requestErrorMessage,
						options: {
							buttons: [
								{
									text: Resources.GOT_IT,
									click: function () {
										$(this).dialog('close');
									}
								}
							],
							title: Resources.SORRY
						}
					});
				}
			}
		});
	} else {
		ajax.getJson({
			url: Urls.checkContainerAvailability,
			data: formData,
			callback: function (data) {
				if (data.success) {
					sendAjaxMessage(formUrl, formData, forwardToComponents);
				} else {
					markTileInvalidQuantity(data.pid, data.qty);
					if (typeof currentHamper !== 'undefined' && currentHamper !== null) {
						formData.Quantity = currentHamper.container.quantity;
					} else {
						formData.Quantity = data.qty;
					}
					dialog.open({
						url: Urls.giftQuantityError,
						options: {
							buttons: [
								{
									text: Resources.EDIT_GIFT_QUANTITY,
									click: function () {
										$(this).dialog('close');
									}
								},
								{
									text: Resources.EDIT_ITEMS_WITHIN_GIFT,
									click: function () {
										sendAjaxMessage(formUrl, formData, forwardToYourComponents);
									}
								}
							],
							dialogClass:'gift-quantity-error yes-and-no-dialog',
							title: Resources.WHOA_THERE
						}
					});
				}
			}
		});
	}
}
function hamperMiniCartLayer () {
	if ($('.uiLayerIndicator').length === 1) {
		return;
	}
	var uiLayer = document.createElement('div');
	uiLayer.className = 'uiLayerIndicator opacity';
	$('body').append($(uiLayer).css('height', $('#wrapper').height()));

	$('.uiLayerIndicator').on('touchstart mousedown', function () {
		var scrollY = window.pageYOffset;
		setTimeout(function () {
			if (window.pageYOffset === scrollY) {
				$('.uiLayerIndicator').remove();
				$('body').find('.hover').removeClass('hover');
			}
		}, 300);
	});

}
module.exports = hampers;
